import axios from 'axios';

const Api = axios.create({
    // eslint-disable-next-line no-undef
    baseURL: wpApiSettings.root,
    headers: {
        'content-type': 'application/json',
        // eslint-disable-next-line no-undef
        // 'X-WP-Nonce': wpApiSettings.nonce
    }
});

export default Api;
